/*
 * Product page out-of-stock CTA state.
 *
 * The theme disables the add-to-cart button at the START of every variant
 * change (variants.js -> onVariantChange -> toggleAddButton(true, "", false))
 * and only re-enables it once the section fetch resolves, roughly 400ms later.
 * Keying the CTA swap off [disabled] therefore made the button vanish on every
 * size change, including a switch between two in-stock sizes.
 *
 * Instead the swap is driven by data-cta-state on the buy-buttons container:
 *
 *   available    add-to-cart button (default)
 *   sold-out     JOIN THE WAITLIST or SOLD OUT, add-to-cart hidden
 *   unavailable  no such variant combination -- add-to-cart stays visible so
 *                the theme can show its own "Unavailable" label
 *
 * The initial value is rendered server-side in main-product.liquid. It is then
 * updated synchronously from the embedded variant JSON, so the swap happens on
 * the same frame as the click, and re-synced from the fetched section HTML in
 * case the embedded inventory data has gone stale.
 */
(function () {
  const CONTAINER_SELECTOR = ".main-product__buy-buttons--container";

  function stateForVariant(variant) {
    if (!variant) return "unavailable";
    return variant.available ? "available" : "sold-out";
  }

  function containerFor(element) {
    const scope = element.closest("section, .wt__quick-buy") || document;
    return scope.querySelector(CONTAINER_SELECTOR);
  }

  function setState(container, state) {
    if (!container || !state) return;
    if (container.dataset.ctaState === state) return;
    container.dataset.ctaState = state;
  }

  // Synchronous: variants.js has already resolved currentVariant by the time
  // variantChangeEnd fires, well before the section fetch comes back.
  document.addEventListener("variantChangeEnd", (event) => {
    const variantOptions = event.target;
    if (!variantOptions || !variantOptions.closest) return;
    setState(
      containerFor(variantOptions),
      stateForVariant(variantOptions.currentVariant),
    );
  });

  // Re-sync from the server-rendered section once the fetch resolves, so a
  // variant that sold out since page load still swaps to the sold-out CTA.
  document.addEventListener("DOMContentLoaded", () => {
    if (typeof subscribe !== "function" || typeof PUB_SUB_EVENTS === "undefined") {
      return;
    }

    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const data = event && event.data;
      if (!data || !data.html || !data.variant) return;

      const submitButton = data.html.getElementById(
        `ProductSubmitButton-${data.sectionId}`,
      );
      if (!submitButton) return;

      const container = document.querySelector(CONTAINER_SELECTOR);
      if (!container) return;

      // Only tighten: never flip a sold-out variant back to available.
      const state = submitButton.hasAttribute("disabled")
        ? stateForVariant(data.variant)
        : "available";
      setState(container, state);
    });
  });
})();
